// Central content for Hybrid Fitness Collective

export const IMAGES = {
  heroA: "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroClass: "https://images.unsplash.com/photo-1517130038641-a774d04afb3c?crop=entropy&cs=srgb&fm=jpg&q=85",
  mat: "https://images.unsplash.com/photo-1591258370814-01609b341790?crop=entropy&cs=srgb&fm=jpg&q=85",
  hyroxBanner: "https://images.unsplash.com/photo-1780398359598-b444653e0d3d",
  skierg: "https://images.unsplash.com/photo-1780398650994-9eb60bdc634a",
  hyroxAthlete: "/hyrox-cta.webp",
  coachTablet: "https://images.unsplash.com/photo-1758875570137-8691b7c55033",
  coachTalk: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/ahwrg5yu_IMG_7144.webp",
  meal1: "https://images.pexels.com/photos/1640775/pexels-photo-1640775.jpeg",
  meal2: "https://images.pexels.com/photos/12050951/pexels-photo-12050951.jpeg",
  emily: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/7zxrpaw2_IMG_20240726_084231_744.jpg",
  highfive: "https://images.unsplash.com/photo-1775654792298-797c44f5d439?crop=entropy&cs=srgb&fm=jpg&q=85",
  highfive2: "https://images.unsplash.com/photo-1764173039313-1422b53003a2?crop=entropy&cs=srgb&fm=jpg&q=85",
  kettlebell: "https://images.pexels.com/photos/13863727/pexels-photo-13863727.jpeg",
  treadmill: "https://images.pexels.com/photos/4944976/pexels-photo-4944976.jpeg",
  trainer: "https://images.pexels.com/photos/8612464/pexels-photo-8612464.jpeg",
};

export const LOGO = {
  wordmarkWhite: "/logo-wordmark.png",
  iconWhiteOrange: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/8em6r2y9_White%20Orange%20Icon%20Hybrid.png",
  iconWhite: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/p6add8nq_white%20icon%20hybrid.png",
};

export const CONTACT = {
  phone: "902-759-8864",
  email: "emilymorton@hybridfitness.com",
  address: "19 Bridge Avenue, Stellarton, NS B0K 0S1",
  hoursShort: "Mon/Tue/Thu/Fri 5:30am–7am · Sat 8am–9am",
  instagram: "https://instagram.com/hybridfitnesspc",
  instagramHandle: "@hybridfitnesspc",
  facebook: "https://www.facebook.com/profile.php?id=61562701265572",
  mapEmbed: "https://www.google.com/maps?q=19+Bridge+Avenue+Stellarton+NS+B0K+0S1&output=embed",
};

export const PROGRAMS = [
  {
    slug: "hybrid-classes",
    title: "Hybrid Classes",
    tagline: "Coached group fitness for every body.",
    price: "$115 / month unlimited",
    blurb: "A blend of strength, conditioning and Hyrox-style training in a room full of people cheering you on.",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/0krn6jwa_IMG_6542.webp",
    points: [
      "60-minute coached sessions from warm-up to cool-down",
      "Every movement scaled to your ability — beginners welcome",
      "Strength, cardio and functional fitness in one class",
      "A community that knows your name",
    ],
  },
  {
    slug: "foundations",
    title: "Foundations",
    tagline: "Your 1-month on-ramp.",
    price: "$149 · 1-month on-ramp",
    blurb: "A one-month on-ramp built for newer athletes. Ease into hybrid training with a weekly one-on-one personal training session — then roll straight into our $115/month unlimited membership, ready and confident.",
    image: "/foundations.webp",
    points: [
      "1-month structured on-ramp program",
      "1x weekly one-on-one personal training session",
      "Ease into hybrid training at your own pace",
      "Rolls into $115/month unlimited membership",
    ],
  },
  {
    slug: "personal-training",
    title: "Personal Training",
    tagline: "One-on-one, all about you.",
    price: "From $75 / session",
    blurb: "Focused, private coaching built entirely around your goals, your schedule and your body.",
    image: "/pt-personal-training.webp",
    points: [
      "Fully personalized programming",
      "Flexible scheduling that fits busy lives",
      "Accountability check-ins between sessions",
      "Ideal for specific goals, injuries or extra attention",
    ],
  },
  {
    slug: "ultimate",
    title: "Ultimate",
    tagline: "Training + nutrition, all in.",
    price: "$199 / month",
    url: "https://hfc.pushpress.com/landing/plans/plan_f490d89f1aba4d",
    blurb: "Our all-in package for members who want the full transformation. Unlimited coached classes paired with personalized 1-on-1 nutrition coaching — so what you do in the gym is matched by how you fuel outside it.",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/479311a468ff043d_renfrewatlanticseries4332.webp",
    points: [
      "Unlimited coached group classes",
      "1-on-1 nutrition coaching built around your life",
      "Progress tracking & regular check-ins",
      "Community events & free reassessments",
    ],
  },
];

export const TESTIMONIALS = [
  { name: "Kelsey R", role: "HFC Member", quote: "I ran my first marathon distance! Thank you for pushing me to do things outside my comfort zone!", rating: 5 },
  { name: "Robin", role: "Member · 2 years", quote: "I've been a member here since day one, and it's all thanks to Steve and Emily. They've created an environment that is warm, safe, completely inclusive, and filled with members who are funny, unfiltered, and unconditionally supportive.", rating: 5 },
  { name: "Melissa", role: "Member · 1 year", quote: "The support, the feeling that we are all in it together, the cheering squad we are for each other, and the fun we do have torturing our coaches each class.", rating: 5 },
  { name: "Tracey", role: "Member · 1 year", quote: "I joined HFC because I wanted to try something new! This gym is more than a place to work out. It's where trust is built, friendships grow and everyone pushes each other to be better.", rating: 5 },
];

export const STORIES = [
  { name: "Robin's Story", stat: "Member: 2 years", quote: "I've been a member here since day one, and it's all thanks to Steve and Emily. They've created an environment that is warm, safe, completely inclusive, and filled with members who are funny, unfiltered, and unconditionally supportive.", image: "/robin-story.webp" },
  { name: "Melissa's Story", stat: "Member: 1 year", quote: "The support, the feeling that we are all in it together, the cheering squad we are for each other, and the fun we do have torturing our coaches each class.", image: "/melissa-story.webp", pos: "center top" },
  { name: "Tracey's Story", stat: "Member: 1 year", quote: "I joined HFC because I wanted to try something new! This gym is more than a place to work out. It's where trust is built, friendships grow and everyone pushes each other to be better.", image: "/tracey-story.webp", pos: "center 58%" },
  { name: "Kelsey's Story", stat: "Member: 1 year", quote: "I joined HFC 10 months ago and my only regret is not doing it sooner! The community here is second to none — I feel supported, encouraged and backed by a group cheering me on through every workout.", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/be3d0bb4702e5775_881894951_1168040172363839_5479466969900862162_n.webp", pos: "center 20%" },
];

export const PRICING = [
  { name: "Drop In", price: "$15", per: "per class", desc: "Just passing through or trying us out.", features: ["Single coached class", "All equipment included", "No commitment"], featured: false, url: "https://hfc.pushpress.com/landing/plans/plan_24d73a66228e44" },
  { name: "Unlimited Membership", price: "$115", per: "per month", desc: "Our most popular option for everyday members.", features: ["Unlimited group classes", "Progress tracking", "Community events", "Free reassessments"], featured: true, url: "https://hfc.pushpress.com/landing/plans/plan_cb7b4285fb524a" },
  { name: "Ultimate", price: "$199", per: "per month", desc: "Everything you need to transform — training plus nutrition.", features: ["Unlimited group classes", "1-on-1 nutrition coaching", "Progress tracking", "Community events & reassessments"], featured: false, url: "https://hfc.pushpress.com/landing/plans/plan_f490d89f1aba4d" },
  { name: "Foundations", price: "$149", per: "1-month on-ramp", desc: "A 1-month on-ramp for newer athletes.", features: ["1-month on-ramp program", "1x weekly personal training", "Ease into hybrid training", "Rolls into $115/mo unlimited"], featured: false, url: "" },
  { name: "Personal Training", price: "From $75", per: "per session", desc: "Private, fully personalized coaching.", features: ["1-on-1 with a coach", "Custom programming", "Flexible scheduling", "Accountability check-ins"], featured: false, url: "" },
];

export const FAQ = [
  { q: "I'm a total beginner. Is this gym for me?", a: "Absolutely. Most of our members started exactly where you are. Every class is coached and every movement is scaled to your ability. You'll never be thrown in the deep end." },
  { q: "What is a Free Intro?", a: "It's a relaxed, no-pressure sit-down with one of our coaches. We learn about your goals, answer your questions, and show you around. It's the best way to see if HFC is right for you." },
  { q: "Do I need to be fit before I start?", a: "Not at all. You get fit by starting — not before. We'll meet you exactly where you are today." },
  { q: "What is Hyrox?", a: "Hyrox is a global fitness race combining running with functional workouts. Our hybrid classes build the strength and endurance for it, but you never have to compete — it's just great, well-rounded training." },
  { q: "How often should I come?", a: "Most members train 3–4 times a week and see fantastic results. We'll help you build a schedule that fits your life." },
  { q: "Where are you located?", a: "We're in the heart of Pictou County, serving New Glasgow, Stellarton, Trenton, Pictou and the surrounding communities." },
];

export const EVENTS = {
  upcoming: [
    {
      title: "Hyrox Ottawa 2027 — Group Prep",
      date: "April 21, 2027",
      dateISO: "2027-04-21T09:00:00-04:00",
      location: "Ottawa, ON",
      blurb: "We're putting together an HFC crew to take on Hyrox Ottawa 2027. We'll coach a select group of members through a dedicated prep block, then travel together to Ottawa to race it as a team. Want in? Let us know you're interested.",
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/479311a468ff043d_renfrewatlanticseries4332.webp",
      link: "https://hfc.pushpress.com/open/interested",
      ctaLabel: "Express Interest",
      tag: "Upcoming",
    },
  ],
  past: [
    {
      title: "The Mangy Coyote — 13 Hour Trail",
      date: "October 24, 2026",
      location: "Trenton Park, Trenton, NS",
      blurb: "Formerly The Backyard Boogeyman — and it was for everyone. Members ran as many 4.5km loops as they liked across 13 hours (9am–10pm), at their own pace. A stocked aid station, crew tents, and awards for Most Loops plus our Spirit of the Pack made for an unforgettable day on the trails.",
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/deb86a21753ebd76_IMG_8592.webp",
      gallery: [
        "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/f15bf13b50ca5fea_IMG_8667.webp",
        "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/bf608a5d2d2e6f68_IMG_8921.webp",
        "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/084835b327da8377_IMG_8588.webp",
      ],
      link: "https://raceroster.com/events/2026/112114/the-mangy-coyote-13-hour-trail",
      ctaLabel: "View on Race Roster",
      tag: "Past Event",
    },
    {
      title: "Hyrox Race Day",
      date: "2025",
      location: "Ottawa, ON",
      blurb: "A crew of HFC members made the trip to take on the Hyrox floor — months of coached training paying off in one unforgettable race day. First-timers and seasoned athletes alike crossed that finish line together.",
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_hfc-stronger/artifacts/ntd8o2mj_637a97cbd8fd179f24b6253d4780b4f4.jpeg",
      link: "https://www.facebook.com/profile.php?id=61583137953356",
      tag: "Past Event",
    },
  ],
};

export const SCHEDULE = {
  days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  classes: {
    Monday: [
      { t: "5:30 AM", end: "6:15 AM", n: "Group Class" },
      { t: "6:15 AM", end: "7:00 AM", n: "Group Class" },
    ],
    Tuesday: [
      { t: "5:30 AM", end: "6:15 AM", n: "Group Class" },
      { t: "6:15 AM", end: "7:00 AM", n: "Group Class" },
    ],
    Wednesday: [
      { t: "4:15 PM", end: "5:00 PM", n: "Hybrid Training Club" },
      { t: "5:15 PM", end: "7:05 PM", n: "PCMHA U13 Dryland", private: true },
    ],
    Thursday: [
      { t: "5:30 AM", end: "6:15 AM", n: "Group Class" },
      { t: "6:15 AM", end: "7:00 AM", n: "Group Class" },
      { t: "5:00 PM", end: "6:55 PM", n: "Mariners Swim Team Dryland", private: true },
    ],
    Friday: [
      { t: "5:30 AM", end: "6:15 AM", n: "Group Class" },
      { t: "6:15 AM", end: "7:00 AM", n: "Group Class" },
      { t: "12:15 PM", end: "1:00 PM", n: "Hybrid Training Club" },
    ],
    Saturday: [
      { t: "8:00 AM", end: "9:00 AM", n: "Strength" },
    ],
  },
};
